// extracted by mini-css-extract-plugin
module.exports = {"sectionSubheading":"SectionSubheading_sectionSubheading__2T78O"};